import { jsx as t } from "react/jsx-runtime";
import { aC as r, aD as o, c as b, d as c } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as f } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as m } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index28.css';const n = "_label_1yv03_1", s = {
  label: n
}, h = f((e, a) => {
  const [{ htmlFor: l }] = r(e, a, o);
  return e.children ? /* @__PURE__ */ t(
    b,
    {
      ...m(e),
      elementType: l ? "label" : "span",
      className: c(s.label, e.className),
      "data-component": "FieldLabel",
      slot: "label",
      children: e.children
    }
  ) : null;
});
export {
  h as FieldLabel
};
